export default __webpack_public_path__ + "static/media/Error_page.80886895.svg";